export default __webpack_public_path__ + "static/media/background-card-menu.036c374f.svg";